export const stripHtml = (text: string) => {
    return text.replace(/<[^>]+>|(  )/g, '');
};


// WEBPACK FOOTER //
// ./src/utils/stripHtml.ts